module.exports = __webpack_public_path__ + "img/845.fc5af160.png";